import styled from 'styled-components';
import { withTheme } from '@canopysecurity/component-library';
export const PageContainer = styled.div`
  padding: 0% 5% 5% 5%;
`;

export const BackgroundContainer = withTheme(styled.div`
  width: 100%;
  padding-top: 20px;
  padding-left: 9px;
  padding-right: 9px;
  background-color: ${({ theme }) => theme.background.surface};
`);

export const FooterContainer = withTheme(styled.div`
  width: 100%;
  padding: 20px 9px;
  background-color: ${({ theme }) => theme.background.surface};
`);
